export default function donationRadio(el: HTMLElement) {
    const radioOptions = el.querySelectorAll<HTMLInputElement>("input[type=radio]");
    const clearButton = el.querySelector<HTMLElement>(".radio-toggle_clear-label");
    const customAmount = el.querySelector<HTMLInputElement>("[data-custom-donation-amount]");

    customAmount?.addEventListener("input", updateSelectedRadioOption);

    for (const opt of radioOptions) {
        opt.addEventListener("input", () => {
            if (opt.checked) {
                customAmount!.value = "";
            }

            toggleClearButtonVisibility();
        });
    }

    if (customAmount?.value) {
        updateSelectedRadioOption();
    }

    toggleClearButtonVisibility();

    function updateSelectedRadioOption() {
        const value = customAmount?.value;
        for (const opt of radioOptions) {
            opt.checked = (opt.value == value);
        }

        toggleClearButtonVisibility();
    }

    function nonZeroAmountSelected() {
        for (const opt of radioOptions) {
            if (opt.checked) {
                return opt.value !== "0";
            }
        }

        if (customAmount!.value !== "") {
            return true;
        }

        return false;
    }

    function toggleClearButtonVisibility() {
        if (clearButton) {
            clearButton.style.display = nonZeroAmountSelected() ? "unset" : "none";
        }
    }
}
